import { Flex, Tooltip } from '@chakra-ui/react';
import { Lightning01 } from '@kula-ai/icons-core';
import type { FlexProps } from '@chakra-ui/react';
import { automationChipHoverProps } from '../automationChipStyles';

export type AutomationBadgeProps = {
  // Hover copy. Omit for a bare, non-interactive badge.
  tooltipLabel?: string;
} & FlexProps;

/**
 * Lightning chip marking stage automation. Badge a stage with an active rule,
 * and only the activities that rule targets — never every card (CORE-4876).
 */
export const AutomationBadge = ({
  tooltipLabel,
  ...flexProps
}: AutomationBadgeProps) => {
  const badge = (
    <Flex
      alignItems="center"
      justifyContent="center"
      bg="pastel-3-light"
      borderRadius="6px"
      // Square by design (CORE-5113): a taller-than-wide chip read as a
      // mis-sized icon next to the stage name.
      boxSize="22px"
      flexShrink={0}
      data-test-id="automation-lock-indicator"
      {...automationChipHoverProps}
      {...flexProps}
    >
      <Lightning01
        size={14}
        color="var(--kula-colors-pastel-3-dark)"
        className="kula-icon"
      />
    </Flex>
  );

  if (!tooltipLabel) return badge;

  return (
    <Tooltip label={tooltipLabel} placement="top" hasArrow shouldWrapChildren>
      {badge}
    </Tooltip>
  );
};
